import {DateRangeFilter, PropertyFilter} from '../schedule/types';
import {VisibleDays} from '../report/types';
import {store} from '../../store/store';
import timeTrackingFiltersReducer, {
    updateDateRangeFilter,
    updatePropertyFilter,
    updateDetailedByDay,
    updateVisibleDays
} from './slice';

export const updateTimeTrackingPropertyFilter = (filter: PropertyFilter) => {
    store.dispatch(updatePropertyFilter(filter));
};

export const updateTimeTrackingDateRangeFilter = (filter: DateRangeFilter) => {
    store.dispatch(updateDateRangeFilter(filter));
};

export const updateTimeTrackingDetailedByDay = (value: boolean) => {
    store.dispatch(updateDetailedByDay(value));
};

export const updateTimeTrackingVisibleDays = (value: VisibleDays) => {
    store.dispatch(updateVisibleDays(value));
};

export { timeTrackingFiltersReducer };
